import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';
import { Loader2 } from 'lucide-react';
import { Header, HeroSection, BenefitsSection, HowItWorksSection, MagicSection, PlansSection, TestimonialsSection, FAQSection, CTASection, Footer, AnimatedSection } from '@/components/landing';

export default function Landing() {
  const { user, loading, signOut } = useAuth();
  const navigate = useNavigate();
  const [isOAuthCallback] = useState(() => {
    const hash = window.location.hash;
    return hash.includes('access_token=') || hash.includes('error=');
  });

  useEffect(() => {
    if (!loading && user) {
      // Validate session before redirecting
      supabase.auth.getUser().then(({ error }) => {
        if (error) {
          console.warn('[Landing] Stale session detected, signing out');
          signOut();
        } else {
          navigate('/dashboard', { replace: true });
        }
      });
    }
  }, [user, loading, navigate, signOut]);

  // Show loader while OAuth callback is being processed
  if (isOAuthCallback && loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-muted-foreground">Entrando com Google...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <HeroSection />
        <AnimatedSection>
          <BenefitsSection />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <HowItWorksSection />
        </AnimatedSection>
        <AnimatedSection delay={150}>
          <MagicSection />
        </AnimatedSection>
        <AnimatedSection delay={100}>
          <PlansSection />
        </AnimatedSection>
        <AnimatedSection>
          <TestimonialsSection />
        </AnimatedSection>
        <AnimatedSection>
          <FAQSection />
        </AnimatedSection>
        <AnimatedSection>
          <CTASection />
        </AnimatedSection>
      </main>
      <Footer />
    </div>
  );
}
